import axios from 'axios';

export default {
  autoComplete({
    state,
    commit,
    getters
  }) {
    return axios
      .get(state.autoCompleteUrl, getters.autoCompleteGetData)
      .then(response => {
        commit('setSuggestions', response.data.categories);
        commit('setDates', response.data.dates.children);
        commit('setTypes', response.data.types.children);
        commit('setDepartures', response.data.departures.children);
      });
  }
}